<div [formGroup]="form">
  <kendo-textbox
    #textbox
    [formControlName]="columnName"
    [attr.autocomplete]="autocomplete || null"
    (blur)="onBlur($event)"
    [skipValidation]="true"
    class="k-input-full"
    >
    <ng-template kendoTextBoxSuffixTemplate>
      <button
        kendoButton
        fillMode="clear"
        [svgIcon]="showPassword ? eyeSlashIcon : eyeIcon"
        (click)="toggleVisibility()"></button>
    </ng-template>
  </kendo-textbox>
</div>
